export default __webpack_public_path__ + "3cf86c7226ca2c6c6001e936b09e06d4.png";